module.exports = __webpack_public_path__ + "img/wireframe.88c75029.png";